import React from 'react';
import classes from "./styles/TitleSection.module.css";

const TitleSection = ({icon, title, subTitle}) => {
  return (
    <div className={classes.titleCon}>
        <img src={icon} alt={title} />
        <div>
          <h1 className={classes.title}>{title}</h1>
          <p className={classes.subTitle}>{subTitle}</p>
        </div>
    </div>
  )
}

export default TitleSection
